import { IMAGES } from 'configs/configs.js'

export const Solid = (icon: string) => `${IMAGES.URL}/solid/${icon}.svg`
export const Outlined = (icon: string) => `${IMAGES.URL}/outlined/${icon}.svg`
